// Single source of truth for company identity.
// COMPANY_LEGAL_NAME is the registered entity and appears on public legal
// surfaces (footer copyright, Terms, Privacy). COMPANY_NAME is the agnostic
// brand used inside the admin/employee/member/client portals and emails, so
// the platform can be reused for another venture without touching copy.
export const COMPANY_NAME = 'AKIVA';
export const COMPANY_LEGAL_NAME = 'AKIVA AI, LLC';
